<template>
    <div class="widget-image">
        <div class="widget-image-item">
            <label v-if="widgetRef.instanceProperties.label" class="field-label"
                :class="{ 'pointer-event-none': mode == 'edit' }" :for="widgetRef.instanceProperties.id">{{
                    widgetRef.instanceProperties.label }}
                <span v-if="widgetRef.validationProperties.required || RulesService.isRequired(widget)">*</span></label>
            <div class="block">
                <UploadField accept="image/jpg, image/jpeg, image/png"
                    v-model:uploadedFile="widgetRef.runtimeProperties.data" class="widget-image-uploader"
                    :class="{ 'pointer-events-none': mode == 'edit', 'fixed-height': mode == 'preview' || mode == 'broadcasting' }"
                    :disabled="disabled">
                    <!-- property file-preview di UploadField ="mettere data uri o url immagine pubblica" -->
                    <div v-if="isFile" class="widget-image-preview alfa">
                        <img :src="preview" />
                        <div class="widget-actions">
                            <img src="/assets/icons/delete.svg" class="icon-normal" @click="removeImage($event)" />
                        </div>
                    </div>
                    <div v-else-if="isString" class="widget-image-preview alfa">
                        <img :src="widgetRef.runtimeProperties.data.path" />
                        <div class="widget-actions">
                            <img src="/assets/icons/delete.svg" class="icon-normal" @click="removeImage()" />
                        </div>
                    </div>
                    <div v-else class="widget-image-browse gamma">
                        <div class="widget-image-placeholder">
                            <div
                                class="flex justify-center items-center p-4 border border-solid border-neutral-normal-light">
                                <img src="/assets/icons/image-upload.svg" class="icon-large" />
                            </div>
                            <div class="flex flex-col items-center">
                                <p><span class="text-green-normal underline">Seleziona l'immagine</span> da caricare.
                                </p>
                                <p>PNG o JPG (max 5mb?)</p>
                            </div>
                        </div>
                    </div>
                </UploadField>
            </div>
        </div>
        <slot></slot>
        <ModalMessages v-if="showMessagesModal" :title="alertTitle" :message="alertMessage" @close="closeMessagesModal">
        </ModalMessages>
    </div>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue';
import { useVModel } from '@vueuse/core';
import ModalMessages from '../../modals/ModalMessages.vue';

// import { useLoggerStore } from '../../../stores/loggerStore';

import UploadField from '../../lib/UploadField.vue';
import RulesService from '../../../services/RulesService';

const props = defineProps({
    mode: {
        type: String,
        default: 'view',
    },
    widget: {
        type: Object,
        required: true,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
});
console.log('PROPS WIDGET IMAGE', props);

const emit = defineEmits(['update:widget']);

const widgetRef = useVModel(props, 'widget', emit, { passive: true, deep: true });
const preview = ref();

const alertTitle = ref();
const alertMessage = ref();
const showMessagesModal = ref(false);

const closeMessagesModal = () => {
    showMessagesModal.value = false;
};

watch(() => widgetRef.value.runtimeProperties.data, (newData, oldData) => {
    if (newData instanceof File) {
        if (newData.size > 5242880) {
            alertTitle.value = "Attenzione!";
            alertMessage.value = "La massima dimensione di una immagine è di 5MB";
            showMessagesModal.value = true;
            widgetRef.value.runtimeProperties.data = oldData;
        } else {
            const reader = new FileReader();
            reader.onload = () => {
                preview.value = reader.result;
            };
            reader.onerror = (error) => {
                console.error(`Error reading file ${newData.name}: ${error}`);
            };
            reader.readAsDataURL(newData);
        }
    }
});
onMounted(() => {
    console.log('MOUNTED');
    if (isFile.value) {
        const reader = new FileReader();
        reader.onload = () => {
            preview.value = reader.result;
        };
        reader.onerror = (error) => {
            console.error(`Error reading file ${widgetRef.value.runtimeProperties.data.name}: ${error}`);
        };
        reader.readAsDataURL(widgetRef.value.runtimeProperties.data);
    }
});
const isFile = computed(() => {
    return widgetRef.value.runtimeProperties.data instanceof File;
});
const isString = computed(() => {
    return typeof widgetRef.value.runtimeProperties.data?.path == 'string';
});
const removeImage = (event) => {
    widgetRef.value.runtimeProperties.data = null;
    event.stopPropagation();
};
</script>

<style lang="postcss" scoped>
.widget-image {
    @apply border-0 w-full;
}

.widget-image-uploader {
    @apply w-full justify-center;
    @apply border border-solid border-neutral-normal-light p-5;
    @apply relative;

    &[disabled='true'] {
        pointer-events: none;
        @apply bg-stone-100;
    }

    .widget-actions {
        /* pointer-events: none; */
        @apply absolute top-0 right-0;
    }
}

.widget-image-browse {
    @apply p-1;
}

.widget-image-placeholder {
    @apply flex flex-col gap-4 items-center text-stone-400;

    img {
        @apply text-stone-400;
    }
}

.widget-image-preview {
    @apply w-full;

    img {
        @apply w-full h-auto;
        object-fit: contain;
    }
}

.widget-image-uploader.fixed-height {
    height: 200px;

    .widget-image-preview {
        @apply h-full;

        img {
            @apply h-full;
            object-fit: contain;
        }
    }
}

.widget-image-item {
    @apply flex flex-col;
}

.widget-image-wrapper {}
</style>
